import React from 'react';

import { createPortal } from 'react-dom';

import Close from '@mui/icons-material/Close';

const ModalWithPortal = ({ isOpenPortal, setIsOpenPortal, children }) => {
  if (!isOpenPortal) return null;

  return createPortal(
    <div
      className="modal-container"
      style={{
        width: '100%',
        height: '100vh',
        top: 0,
        position: 'absolute',
        left: 0,
        zIndex: '99999999999999999999999',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        boxShadow: '0 3px 10px 0 rgb(0 0 0 / 7 %)',
        overflow: 'hidden',
        animation: 'display - modal -in 0.3s ease -in -out',
        padding: '2em',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
      }}
      onClick={() => setIsOpenPortal(false)}
    >
      {children}
      <div
        style={{
          position: 'absolute',
          top: '3em',
          right: '3em',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'center',
        }}
        onClick={() => setIsOpenPortal(false)}
      >
        <Close fontSize="large" style={{ color: '#fff' }} />
      </div>
    </div>,

    document.getElementById('canvas')
  );
};

export default ModalWithPortal;
